import { Zap } from "lucide-react";
import { cn } from "@/lib/utils";

interface NavCreditsDisplayProps {
  credits: number;
  maxCredits: number;
  creditsPercentage: number;
  creditsLabel: string;
  remainingLabel: string;
  className?: string;
}

export function NavCreditsDisplay({
  credits,
  maxCredits,
  creditsPercentage,
  creditsLabel,
  remainingLabel,
  className,
}: NavCreditsDisplayProps) {
  return (
    <div className={cn("border-t border-border pt-3", className)}>
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm text-muted-foreground flex items-center gap-1">
          <Zap className="w-4 h-4 text-primary" />
          {creditsLabel}
        </span>
        <span className="font-bold text-foreground">
          {credits} / {maxCredits}
        </span>
      </div>

      <div className="w-full h-2 bg-secondary rounded-full overflow-hidden mb-1">
        <div
          className="h-full bg-primary rounded-full transition-all"
          style={{ width: `${creditsPercentage}%` }}
        />
      </div>
      <p className="text-xs text-muted-foreground text-end">
        {creditsPercentage}% {remainingLabel}
      </p>
    </div>
  );
}
